// PRODUCT テキストスクロール
document.addEventListener("DOMContentLoaded", () => {
  const text = document.querySelector(".productScroll > div");
  if (!text) return; // 要素が存在しない場合は何もしない

  let active = false;

  // 要素が画面に入ったか監視
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      active = entry.isIntersecting; // 画面内にあるかどうか
      if (active) {
        text.classList.add("active");
      } else {
        text.classList.remove("active");
      }
    });
  });

  observer.observe(text);

  // スクロール時の動き
  window.addEventListener("scroll", () => {
    if (!active) return; // 画面外なら動かさない

    const rect = text.getBoundingClientRect();
    const moveX = (window.innerHeight - rect.top) * 0.5; // スクロール量に応じて動く

    text.style.transform = `translateX(${moveX}px)`;
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (!document.getElementById("main-carousel")) return;

  var main = new Splide("#main-carousel", {
    type: "loop",
    rewind: true,
    pagination: false,
    arrows: false,
  });

  var thumbnails = new Splide("#thumbnail-carousel", {
    fixedWidth: 80,
    fixedHeight: 80,
    gap: 5,
    rewind: true,
    pagination: false,
    cover: true,
    isNavigation: true,
    breakpoints: {
      600: {
        fixedWidth: 60,
        fixedHeight: 60,
      },
    },
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();
});
